import React, { useEffect, useState, useMemo } from "react";
import {
  Toolbar,
  CssBaseline,
  Box,
  useMediaQuery,
  useTheme,
  Drawer,
  Grid,
} from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "../LayoutComponents/TopBar";
import SideDrawer from "../LayoutComponents/SideDrawer";
import { MainLayoutStyles } from "../../Styles/styles";

const drawerWidth = 300;

const pageNames = {
  "/eventmanagement": "Create Events/Tickets",
  "/QRCode-upload": "Scan Tickets",
  "/verify-code": "Verify with Code",
  "/verify-name": "Verify with Name",
  "/add-event": "Add Event",
  "/dashboard": "Dashboard",
  "/mytickets": "My Tickets",
  "/eventinvites": "Event Invites",
  "/mybookings": "My Bookings",
  "/add-user": "Add User",
  "/event-organizer": "Event Organizer Management",
  "/add-organizer": "Add New Organizer",
  "/raffle-management": "Raffle Management",
  "/settings": "Settings",
  "/user-dashboard": "User Dashboard",
  "/user-events": "User Events",
  "/user-tickets": "User Tickets",
  "/user-raffles": "User Raffles",
  "/user-settings": "User Settings",
  "/organizer-dashboard": "Organizer Dashboard",
  "/organizer-teams": "Organizer Teams",
  "/organizer-raffles": "Organizer Raffles",
  "/organizer-settings": "Settings",
  "/ticket-booking": "Booking",
  "/explore-events": "Explore Events",
  "/event-detail": "Event Detail",
  "/createtickets": "Create Tickets",
  "/all-tickets": "All Tickets",
  "/show-templates": "Templates",
  "/ticket-display": "Generated Tickets",
};

export default function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showBackIcon, setShowBackIcon] = useState(false);
  const [currentUser] = useState({ role: "commonUser" });

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const location = useLocation();
  const { pathname } = location;

  const pageName = useMemo(() => {
    if (pathname.startsWith("/event-detail")) {
      return "Event Details";
    }
    return pageNames[pathname] || "";
  }, [pathname]);

  useEffect(() => {
    setShowBackIcon(
      ["/add-event", "/add-user", "/add-organizer"].includes(pathname)
    );
  }, [pathname]);

  const theme = useTheme();
  const isMediumOrLarger = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <CssBaseline />
      <Grid container sx={{ overflow: "hidden" }}>
        <Grid
          item
          xl={2}
          md={3}
          xs={8}
          sx={{ maxHeight: "100vh", overflow: "hidden" }}
        >
          <Box
            sx={{
              marginTop: { xs: -1, sm: -0.3, md: 0.3, lg: 0.3, xl: 0.3 },
              margin: 0.3,
            }}
          >
            {!isMediumOrLarger ? (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                setMobileOpen={setMobileOpen}
                mobileOpen={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={MainLayoutStyles.MobileDrawer}
              >
                <SideDrawer
                  userRole={currentUser.role}
                  selectedIndex={selectedIndex}
                  handleListItemClick={handleListItemClick}
                  setMobileOpen={setMobileOpen}
                />
              </Drawer>
            ) : (
              <SideDrawer
                setMobileOpen={setMobileOpen}
                userRole={currentUser.role}
                selectedIndex={selectedIndex}
                handleListItemClick={handleListItemClick}
              />
            )}
          </Box>
        </Grid>

        <Grid
          item
          xl={10}
          md={9}
          xs={12}
          sx={{ maxHeight: "100vh", overflow: "auto" }}
        >
          <TopBar
            position="fixed"
            drawerWidth={drawerWidth}
            handleDrawerToggle={handleDrawerToggle}
            pageName={pageName}
            showBackIcon={showBackIcon}
          />
          <Toolbar />
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
}
